import { render } from "./X5332.vue?vue&type=template&id=2c04c684"
import script from "./X5332.vue?vue&type=script&lang=js"
export * from "./X5332.vue?vue&type=script&lang=js"

import "./X5332.vue?vue&type=style&index=0&id=2c04c684&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__